/*import ChatService from "@/services/ChatService";

class WebRTC {
    peerConnection = null;
    localStream = null;
    remoteStream = null;
    chatService = null;
    handleHangoutCallback = null;

    constructor(store, chatService) {
        this.store = store;
        this.chatService = chatService; // Recibe la instancia de ChatService
    }

    async setupPeerConnection() {
        // RemoteStream espera los tracks que se envían del otro lado
        this.remoteStream = new MediaStream();
        this.peerConnection.addEventListener('track' ,(event) => {
            event.streams[0].getTracks().forEach((track) => {
                this.remoteStream.addTrack(track);
            });
        });
        return this.remoteStream;
    }

    async setRTC() {
        const servers = {
            iceServers: [{ urls: ['stun:stun1.1.google.com:19302', 'stun:stun2.1.google.com:19302'] }]
        };
        // Crear nueva conexión del RTC
        this.peerConnection = new RTCPeerConnection(servers);
        // Almacenar la información de dispositivos para la llamada
        this.localStream = await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: {deviceId: this.chatService.store.state.audioInput ? {exact: this.chatService.store.state.audioInput} : undefined}
        })
        // Enviar las pistas a transmitir por PeerConnection
        await this.localStream.getTracks().forEach((track) => this.peerConnection.addTrack(track, this.localStream));

        const blackCanvas = document.createElement('canvas');
        blackCanvas.width = 640;
        blackCanvas.height = 480;
        const context = blackCanvas.getContext('2d');
        context.fillStyle = 'black';
        context.fillRect(0, 0, blackCanvas.width, blackCanvas.height);
        const blackStream = blackCanvas.captureStream();
        const blackVideoTrack = blackStream.getVideoTracks()[0];
        this.peerConnection.addTrack(blackVideoTrack, this.localStream);
    }

    // async shareScreen(screenStream) {
    //     const screenTrack = screenStream.getVideoTracks()[0];
    //     this.chatService.sendShareNotify('true'); // Usar la instancia de ChatService
    //     document.getElementById('localVideo').srcObject = await this.remoteStream;
    //     document.getElementById('remoteVideo').srcObject = screenStream;
    //     const sender = this.peerConnection.getSenders().find(s => s.track && s.track.kind === 'video');
    //     console.log(sender);
    //     if (sender) {
    //         sender.replaceTrack(screenTrack);
    //     } else {
    //         this.peerConnection.addTrack(screenTrack, screenStream);
    //     }
    //     screenTrack.onended = () => {
    //         this.isSharingScreen = false;
    //         document.getElementById('localVideo').srcObject = null;
    //         document.getElementById('remoteVideo').srcObject = this.remoteStream;
    //
    //         this.chatService.sendShareNotify('false'); // Usar la instancia de ChatService
    //     };
    // }

    async getRemoteVideo(){
        return this.remoteStream;
    }
    acceptCallCallback = null;
    setAcceptCallCallback(callback) {
        // Asigna el callback pasado como argumento a la propiedad acceptCallCallback
        this.acceptCallCallback = callback;
    }
    setHandleHangoutCallback(callback) {
        this.handleHangoutCallback = callback;
    }

    async toggleMute(){
        if (this.peerConnection) {
            const audioTrack = this.localStream.getAudioTracks()[0];
            if (audioTrack) {
                this.isAudioMuted = !this.isAudioMuted;
                audioTrack.enabled = !this.isAudioMuted;
            }
        }
    }

    // async toggleCam(){
    //     if (this.localStream) {
    //         const videoTrack = this.localStream.getVideoTracks()[0];
    //         if (videoTrack) {
    //             this.isVideoMuted = !this.isVideoMuted;
    //             videoTrack.enabled = !this.isVideoMuted;
    //         }
    //     }
    // }

    async initializePeerConnection(data) {
        if (data.peerConnection && this.peerConnection) {
            switch (data.peerConnection.type) {
                case 'offer':
                    await this.handleOffer(data);
                    await this.sendCandidates();
                    break;
                case 'answer':
                    await this.handleAnswer(data);
                    break;
                case 'candidate':
                    this.peerConnection.addIceCandidate(new RTCIceCandidate(data.peerConnection.candidate))
                        .catch(e => console.error("Error adding ICE candidate:", e));
                    break;
                case 'hangout':
                    this.hangout()// Llama a handleHangout desde el componente Stream
                    break;
            }
        }
    }

    hangout(){
        if (this.handleHangoutCallback) {
            // Se ejecuta el Callback
            this.handleHangoutCallback(); 
        }
    }

    // Maneja una oferta y crea una respuesta
    async handleOffer(data){
        await this.setupPeerConnection();
        await this.peerConnection.setRemoteDescription(new RTCSessionDescription(data.peerConnection));
        const answer = await this.peerConnection.createAnswer();
        await this.peerConnection.setLocalDescription(answer);

        if (this.acceptCallCallback) {
            // Se ejecuta el Callback
            this.acceptCallCallback();
        }
        this.chatService.conn.send(JSON.stringify({
            'data': {
                'thread': this.chatService.store.state.id,
                'token': this.chatService.store.state.token,
                'act': 'calling'
            },
            'peerConnection': answer
        }));
        // Se guarda la ubicación la cual se ha iniciado la llamada
        localStorage.setItem('video_call', window.location.pathname);
        localStorage.setItem('recall', true);
        // Crea un iframe con la página de fondo
        this.iframe();
    }

    async handleAnswer(data) {
        if (!this.peerConnection.currentRemoteDescription) {
            await this.peerConnection.setRemoteDescription(new RTCSessionDescription(data.peerConnection));
            localStorage.setItem('recall', true);
        }
    }

    iframe(){
        if (!document.querySelector('#iframeContainer')) {
            // Clona el header y el body
            const headClone = document.head.cloneNode(true);
            const bodyClone = document.body.cloneNode(true); // Clonamos el body actual

            if (bodyClone.querySelector('personal-web-shopper')) {
                bodyClone.querySelector('personal-web-shopper').remove(); // Eliminamos el chat del body clonado

                if (!this.iframeContainer) { // Creamos el contenedor del iframe solo una vez
                    this.iframeContainer = document.createElement('div');
                    this.iframeContainer.id = 'iframeContainer';
                    Object.assign(this.iframeContainer.style, {
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        zIndex: '9999',
                        backgroundColor: 'white'
                    });
                }

                // Crea el iframe
                const iframe = document.createElement('iframe'); // Creamos el iframe
                Object.assign(iframe.style, {
                    width: '100%',
                    height: '100%',
                    border: 'none'
                });

                this.iframeContainer.appendChild(iframe); // Insertamos el iframe en el contenedor

                // Lo agrega al body de la página principal
                document.body.appendChild(this.iframeContainer);

                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document; // Accedemos al contenido del iframe

                // Reemplazamos el contenido del iframe
                const htmlContent = document.createElement('html');
                const headContent = headClone.cloneNode(true); // Clonar el contenido del <head>
                const bodyContent = bodyClone.cloneNode(true); // Clonar el contenido del <body>

                // Agregar el contenido clonado al iframe
                htmlContent.appendChild(headContent);
                htmlContent.appendChild(bodyContent);

                // Limpiar el documento del iframe y reemplazarlo
                iframeDoc.documentElement.replaceWith(htmlContent);

                // Monitorizamos la URL del iframe (si es necesario)
                this.monitorIframeURL(iframe);
            }
        }
    }

    // Revisa las redirecciones que se están haciendo en el iframe y almacena la url nueva
    monitorIframeURL(iframe) {
        let lastUrl = iframe.contentWindow.location.href;
        setInterval(() => {
            const currentUrl = iframe.contentWindow.location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;
                // Cambia la url de la pagina principal para que sea la misma a la del iframe
                window.history.pushState({}, '', currentUrl);
            }
        }, 1000);
    }

    // Inicia la llamada
    startCall() {
        this.chatService.setInCall(1);
        this.chatService.sendAnswer(
            { thread: this.store.state.id, token: this.store.state.token, act: 'calling' },
            { 'type': 'calling' }
        );
    }

    // Enviar los candidatos
    sendCandidates(){
        this.peerConnection.onicecandidate = (event) => {
            if (event.candidate) {
                this.chatService.conn.send(JSON.stringify({
                    "data": {
                        'thread': this.chatService.store.state.id,
                        'token': this.chatService.store.state.token,
                        'act': "calling" },
                    'peerConnection':
                        {
                            'type': 'candidate',
                            'candidate': event.candidate
                        }
                }));
            }
        };
    }

    // Crea la oferta
    createOffer() {
        if (this.peerConnection) {
            this.peerConnection.createOffer()
                .then(async (offer) => {
                    await this.peerConnection.setLocalDescription(offer);
                })
                .then(() => {
                    const obj = {
                        thread: this.chatService.store.state.id,
                        token: this.chatService.store.state.token,
                        act: 'calling'
                    };
                    this.chatService.sendAnswer(obj, this.peerConnection.localDescription); // Usar la instancia de ChatService
                });
        }
    }

    // Revisa si existe un remoto en el peerConnection
    async checkPeerConnection(){
        return await this.peerConnection.remoteDescription;
    }

    // Elimina la conexión con el peerConnection
    removePeerConnection() {
        if(this.peerConnection){
            const obj = {
                thread: this.chatService.store.state.id,
                token: this.chatService.store.state.token,
                act: 'calling'
            };
            this.localStream.getTracks().forEach(track => track.stop());
            this.chatService.sendAnswer(obj, { 'type': 'hangout' }); // Usar la instancia de ChatService
            this.peerConnection = null;
            this.localStream = null;
            this.remoteStream = null;
        }
    }
}

export default WebRTC;
*/